import React, { useState } from "react";
import { Mail, Globe, Loader2, CheckCircle } from "lucide-react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", company: "", email: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // EmailJS template parameters
    const templateParams = {
      name: formData.name,
      company: formData.company,
      email: formData.email, // Appears in email body
      message: formData.message,
      to_email: "support@searchy.io", // Allows direct reply to client's email
      domain: "Searchy.io", // Appears nicely in the template
    };

    emailjs
      .send(
        "service_xz6w6qs", // Your Service ID (e.g., service_xyz)
        "template_23fhgwe", // Your Template ID
        templateParams,
        "rcAXGSHdPuM8yQQip" // Your Public Key (found in EmailJS under Account > General)
      )
      .then(
        (result) => {
          console.log("Email sent successfully:", result.text);
          setIsSubmitting(false);
          setIsSent(true);
          setFormData({ name: "", company: "", email: "", message: "" }); // Reset form

          // Reset success message after 5 seconds to allow sending again
          setTimeout(() => setIsSent(false), 5000);
        },
        (error) => {
          console.error("Email send failed:", error.text);
          setIsSubmitting(false);
          alert("Failed to send message. Please try again later.");
        }
      );
  };

  return (
    <div className="min-h-screen bg-slate-50 pt-32 pb-20 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col md:flex-row">
        {/* Left Side (Dark Info) */}
        <div className="md:w-1/3 bg-slate-900 p-10 text-white flex flex-col justify-between">
          <div>
            <h2 className="text-2xl font-bold mb-4">Contact Info</h2>
            <p className="text-slate-400 mb-8">Reach out to our business development team.</p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-blue-500" /> support@searchy.io
              </div>
              <div className="flex items-center gap-3">
                <Globe className="h-5 w-5 text-blue-500" /> searchy.io
              </div>
            </div>
          </div>
        </div>

        {/* Right Side (Form) */}
        <div className="md:w-2/3 p-10 md:p-14 relative">
          <h2 className="text-3xl font-bold text-slate-900 mb-8">Send a Message</h2>

          {isSent ? (
            <div className="h-full flex flex-col items-center justify-center text-center animate-in fade-in zoom-in duration-500 py-10">
              <div className="h-20 w-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <CheckCircle className="h-10 w-10 text-green-600" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-2">Message Sent!</h3>
              <p className="text-slate-500">
                Thank you for reaching out. We will get back to you shortly.
              </p>
              <button
                onClick={() => setIsSent(false)}
                className="mt-8 text-blue-600 font-bold hover:underline"
              >
                Send another message
              </button>
            </div>
          ) : (
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="grid grid-cols-2 gap-6">
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full p-4 bg-slate-50 border-transparent rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition outline-none"
                  placeholder="Name"
                />
                <input
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full p-4 bg-slate-50 border-transparent rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition outline-none"
                  placeholder="Company"
                />
              </div>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-4 bg-slate-50 border-transparent rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition outline-none"
                placeholder="Email Address"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full p-4 bg-slate-50 border-transparent rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition outline-none h-32"
                placeholder="Tell us about your traffic needs..."
              ></textarea>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-600 text-white font-bold py-4 rounded-xl hover:bg-blue-700 transition shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="h-5 w-5 animate-spin" /> Sending...
                  </>
                ) : (
                  "Submit Inquiry"
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
